import { render, staticRenderFns } from "./AccountHolderBilling.vue?vue&type=template&id=642074c4&scoped=true"
import script from "./AccountHolderBilling.vue?vue&type=script&lang=ts"
export * from "./AccountHolderBilling.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderBilling.vue?vue&type=style&index=0&id=642074c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642074c4",
  null
  
)

export default component.exports